import {format, utcToZonedTime, zonedTimeToUtc} from 'date-fns-tz';

import {TIME_ZONE_ALMATY} from '../../constants/date';

import {DEFAULT_CITY, OLD_SELECTED_CITY, SELECTED_CITY} from './constants';
import {getCookie} from './cookie';

// input *new Date()
export const dateFormatter = date => {
  const year = date.getFullYear();

  let month = date.getMonth() + 1;

  let dt = date.getDate();

  if (dt < 10) {
    dt = `0${dt}`;
  }
  if (month < 10) {
    month = `0${month}`;
  }
  // output format yyyy-mm-dd
  return `${year}-${month}-${dt}`;
};

export const dateFormatterText = date => {
  const dateObject = new Date(date);
  const year = dateObject.getFullYear();

  let month = dateObject.getMonth() + 1;

  let dt = dateObject.getDate();

  if (dt < 10) {
    dt = `0${dt}`;
  }
  if (month < 10) {
    month = `0${month}`;
  }
  // output format dd.mm.yyyy
  return `${dt}.${month}.${year}`;
};

// input "string"
export const miniDateFormatter = date => {
  const newDate = new Date(date);

  let month = newDate.getMonth() + 1;

  let dt = newDate.getDate();

  if (dt < 10) {
    dt = `0${dt}`;
  }
  if (month < 10) {
    month = `0${month}`;
  }
  // output format dd.mm
  return `${dt}.${month}`;
};

const formatDateTime = date => {
  const utc = zonedTimeToUtc(date);

  return utcToZonedTime(utc, TIME_ZONE_ALMATY);
};

/**
 * Format date to KZ format by param
 * @param {string | Date | number} date - Date to format
 * @param {'full' | 'time'| 'date'} printFormat - Format for date transform
 * @return {string|*} - Date formatted
 */
export const getKzDateTime = (date, printFormat) => {
  if (date) {
    const formattedDate = formatDateTime(date);

    switch (printFormat) {
      case 'full':
        return format(formattedDate, 'yyyy-MM-dd\'T\'HH:mm:ssXXX', {timeZone: TIME_ZONE_ALMATY});
      case 'time':
        return format(formattedDate, 'HH:mm', {timeZone: TIME_ZONE_ALMATY});
      case 'date':
        return format(formattedDate, 'dd.MM', {timeZone: TIME_ZONE_ALMATY});
      default:
        return '';
    }
  }
  return '';
};

export const signMap = {
  '-1': 'down',
  1: 'up',
  0: ''
};

export const currencyFormatter = value => parseFloat(value).toFixed(2);

export const deltaFormatter = value => value.toString().replace('-', '');

export const scrollToRef = (ref, offset) => window.scrollTo(0, ref.current.offsetTop - offset);

export const platform = {
  desktop: window.innerWidth > 768,
  mobile: window.innerWidth <= 768
};

export const getSavedLocation = () => window.Site?.nurfin?.city ||
  JSON.parse(getCookie(SELECTED_CITY)) ||
  window.localStorage.getItem(OLD_SELECTED_CITY) ||
  DEFAULT_CITY;

export const getUrlParameters = name => {
  const url = window.location.href;
  const stringName = name.replace(/[\[\]]/g, '\\$&');
  const regex = new RegExp(`[?&]${stringName}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(url);

  if (!results) {
    return null;
  }
  if (!results[2]) {
    return '';
  }
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

export const getCityTranslateByKey = key => window.Site?.nurfin?.cities[key];

export const checkOpeningTimes = (hoursOpen, hoursClose) => {
  const currentKazHours = format(formatDateTime(new Date()), 'HH', {timeZone: TIME_ZONE_ALMATY});

  return currentKazHours >= hoursOpen && currentKazHours < hoursClose; // time work hours between open - close
};

export const enableScroll = () => {
  const scrollY = document.body.style.top;

  document.body.style.position = '';
  document.body.style.top = '';
  window.scrollTo(0, parseInt(scrollY || '0', 10) * -1);
};

export const disableScroll = () => {
  document.body.style.top = `-${window.scrollY}px`;
  document.body.style.position = 'fixed';
};

export const getTokenPayload = token => {
  if (!token) {
    return {};
  }

  const tokenPayload = token.split('.')[1];

  try {
    return JSON.parse(atob(tokenPayload));
  } catch (e) {
    return {};
  }
};

export const formatOnlyNumbers = (anyString = '') => +anyString.replace(/[^\d]/g, '');

export const formatPhoneValue = (str = '') => str.replace('+87', '+77').replace(/\s/g, '');

export const isToday = date => {
  if (new Date().toDateString() === new Date(date).toDateString()) {
    return 'сейчас';
  }
  return dateFormatterText(date);
};
